import { PaintedScene } from '../PaintedScene';

export const FROZEN_LAKE_PHASER_KEY = 'FrozenLakeScene' as const;
export const FROZEN_LAKE_MANIFEST_KEY = 's-312-frozen-lake' as const;

export class FrozenLakeScene extends PaintedScene {
  constructor() {
    super(FROZEN_LAKE_PHASER_KEY, FROZEN_LAKE_MANIFEST_KEY);
  }
}
